/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState, useCallback } from 'react';
import { ARMcontext } from '../../../utils/context/context';
import { Teams } from '../../../utils/api';
import { FluidContainer, TablePlayersWellness, Loader } from '../../../components';
import { TableWrapper } from './styles';
import PaginationControls from '../../../components/PaginationControls/PaginationControls';
import { CacheKeysTables, KeyWellnessCache } from '../../../utils/constants/keyCache';
import { getQueryCacheForTable } from '../../../utils/helpers/queryCacheKey';

export default ({
  isFirstLoad,
  playersGroup,
  playerNameSearch,
}: {
  isFirstLoad: boolean;
  playersGroup: string;
  playerNameSearch: string;
}) => {
  const [exams, useExams] = useState<Array<object | any>>([]);
  const [teamAverage, useTeamAverage] = useState({});
  const { HandleToastMessage, selectedTeam, triggerRefresh, setTriggerRefresh } = useContext(ARMcontext);
  const [loadingTable, setLoadingTable] = useState(true);
  const [isFirstLoadWellness, setFirstLoadWellness] = useState(true);
  const [currentPlayerSearch, setCurrentPlayerSearch] = useState(playerNameSearch);
  const TEAMS = new Teams();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    recordsPerPage: 20
  });

  const [sortConfig, setSortConfig] = useState({ key: 'firstName', direction: 'desc' });

  const handleSort = useCallback((key) => {
    setSortConfig(prevSort => ({
      key,
      direction: prevSort.key === key && prevSort.direction === 'asc' ? 'desc' : 'asc',
    }));
  }, []);


  useEffect(() => {
    getWellnessRecords();
  }, [playersGroup, selectedTeam.__name, pagination.currentPage, pagination.recordsPerPage, sortConfig, playerNameSearch]);

  useEffect(() => {
    setFirstLoadWellness(false)
  }, []);

  const triggerReloadWellness = async () => {
    await getWellnessRecords();
    setTriggerRefresh({
      ...triggerRefresh,
      wellness: false
    })
  }
  useEffect(() => {
    if(triggerRefresh.wellness)
      getWellnessRecords()
  }, [triggerRefresh.wellness])

  async function getWellnessRecords() {
    setLoadingTable(true);
    const isSamePlayerNameSearch = currentPlayerSearch === playerNameSearch;

    const wellnessDataKey = getQueryCacheForTable({
      selectedTeam,
      playersGroup,
      page: pagination.currentPage,
      recordsPerPage: pagination.recordsPerPage,
      sortBy: sortConfig.key,
      sortOrder: sortConfig.direction,
      mainCacheKey: KeyWellnessCache.table,
      playerNameSearch,
    })
    const examsResponse = await TEAMS.ExecuteCacheRequest({
      isForceDelete: !isSamePlayerNameSearch,
      cacheKey: wellnessDataKey.cacheKey,
      queryFn: () => TEAMS.GetWellnessRecords(
        selectedTeam._id,
        playersGroup,
        playerNameSearch,
        pagination.currentPage,
        pagination.recordsPerPage,
        sortConfig.key,
        sortConfig.direction
      ),
    })


    if (examsResponse.status) {
      useExams(examsResponse.data.records);
      setPagination(prev => ({
        ...prev,
        currentPage: examsResponse.data.pagination.currentPage,
        totalPages: examsResponse.data.pagination.totalPages,
        totalItems: examsResponse.data.pagination.totalItems,
      }));
      setCurrentPlayerSearch(playerNameSearch);


      const keyAvg = CacheKeysTables(KeyWellnessCache.avg, wellnessDataKey.secondaryCacheOpts);
      TEAMS.ExecuteCacheRequest({
        isForceDelete: !isSamePlayerNameSearch,
        cacheKey: keyAvg,
        queryFn: () =>
          TEAMS.GetWellnessRecordsTeamAverage(selectedTeam._id, playersGroup)
      }).then((averageResult) => {
        if (averageResult.status && averageResult.data) {
          useTeamAverage(averageResult.data.teamAverage);
        }
      }).catch(err => console.error('Failed to fetch wellness average exams:', err))
    } else {
      HandleToastMessage(examsResponse?.data?.message || 'Server error', true, 2000, 'error');
    }
    setLoadingTable(false);
  }

  return (
    <>
      <FluidContainer>
        <TableWrapper>
          {loadingTable ? (
            <div style={{ width: "100%", display: 'block', alignItems: 'center' }}><Loader height="90px" /></div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column'}}>
            <TablePlayersWellness
             filter={playerNameSearch}
              dataTableContent={exams}
              teamAverage={teamAverage}
              minWidth="1200px"
              handleSort={handleSort}
              sortBy={sortConfig.key}
              sortOrder={sortConfig.direction}
               />
            <PaginationControls
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            totalItems={pagination.totalItems}
            recordsPerPage={pagination.recordsPerPage}
            onPageChange={(page) => setPagination(prev => ({ ...prev, currentPage: page }))}
            onLimitChange={(limit) => setPagination(prev => ({ ...prev, recordsPerPage: limit, currentPage: 1 }))}
          />
          </div>
          )}
        </TableWrapper>
      </FluidContainer>
    </>
  );
};
